import React, { useState } from "react";
import { Globe, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "@/i18n";

const hasChoice = () => { try { return !!localStorage.getItem("vb.lang"); } catch { return true; } };

// Mobile: inline under the header (in page flow) so it never covers cards; desktop: unchanged floating card.
export default function LanguagePrompt() {
  const { i18n } = useTranslation();
  const [show, setShow] = useState(() => !hasChoice());
  if (!show) return null;
  const choose = (code) => {
    i18n.changeLanguage(code);
    try { localStorage.setItem("vb.lang", code); } catch { /* storage blocked: language still applies for this session */ }
    setShow(false);
  };
  return (
    <div className="relative mx-3 mt-3 sm:mx-0 sm:mt-0 sm:fixed sm:bottom-5 sm:start-4 sm:z-40 sm:w-[calc(100%-6rem)] sm:max-w-xs bg-white border border-emerald-100 shadow-lg shadow-black/10 rounded-2xl p-3" data-testid="language-prompt">
      <button onClick={() => choose(i18n.language || "en")} className="absolute top-2 end-2 p-1 text-slate-400 hover:text-slate-700" aria-label="Close" data-testid="language-prompt-close"><X className="w-4 h-4" /></button>
      <div className="flex items-center gap-2 text-sm font-semibold text-slate-900 pe-6"><Globe className="w-4 h-4 text-emerald-700" /> Choose language · भाषा चुनें</div>
      <div className="mt-2 flex flex-wrap gap-1.5">
        <button onClick={() => choose("en")} className="rounded-full bg-emerald-700 text-white px-3 py-1 text-xs font-semibold" data-testid="language-prompt-en">English</button>
        <button onClick={() => choose("hi")} className="rounded-full bg-amber-500 text-white px-3 py-1 text-xs font-semibold" data-testid="language-prompt-hi">हिन्दी</button>
        <select onChange={(e) => e.target.value && choose(e.target.value)} defaultValue="" className="rounded-full border border-slate-200 px-2 py-1 text-xs" data-testid="language-prompt-more">
          <option value="">More…</option>
          {LANGUAGES.filter((l) => !["en", "hi"].includes(l.code)).map((l) => <option key={l.code} value={l.code}>{l.label}</option>)}
        </select>
      </div>
    </div>
  );
}
